import React from 'react'
import { Paragraph, Text } from 'theme-ui'
import { CONTROLDText } from 'ui/CONTROLD'
import { FAQItem } from 'components/FrequentlyAskedQuestions'
import StyledLink from 'components/Organization/LandingPageCommonComponents/StyledLink'

export const frequentlyAskedQuestions: FAQItem[] = [
  {
    question: `What is service filtering, and how does it work?`,
    answer: (
      <Paragraph>
        Service filtering is a tool that controls access to specific online services or applications
        within a business network. It works by recognizing and selectively allowing or blocking
        certain services, like streaming or file-sharing apps, based on customized business
        policies, helping maintain productivity and security.
      </Paragraph>
    ),
  },
  {
    question: 'Why do businesses need service filtering?',
    answer: (
      <Text>
        <Paragraph>
          Service filtering helps businesses ensure that only relevant, approved online services are
          accessible during work hours. This control prevents unnecessary use of bandwidth, reduces
          distractions, and protects the network from potentially harmful applications, enhancing
          both productivity and security.
        </Paragraph>
        <br />
        <Paragraph>
          {CONTROLDText} offers highly flexible filtering rules, allowing you to create policies
          that suit different teams, departments, or individual devices. You have full control over
          which services are accessible on your network.
        </Paragraph>
      </Text>
    ),
  },
  {
    question: 'Can service filtering boost employee productivity?',
    answer: (
      <Text>
        <Paragraph>
          Yes, service filtering helps by limiting access to non-work-related services and
          applications that could be distracting. By enabling access only to tools essential for
          business, companies can create an environment focused on core tasks and goals, leading to
          a more productive workforce.
        </Paragraph>
        <br />
        <Paragraph>
          {CONTROLDText}&apos;s service filtering allows you to tailor settings to block only
          unnecessary or distracting services while ensuring employees have access to the resources
          they need to complete their work.
        </Paragraph>
      </Text>
    ),
  },
  {
    question: `How does service filtering protect against security threats?`,
    answer: (
      <Paragraph>
        By restricting access to unauthorized or high-risk services, service filtering reduces the
        risk of malware, phishing, and other cyber threats. It prevents employees from accessing
        potentially compromised or risky applications that could expose the business network to
        vulnerabilities.
      </Paragraph>
    ),
  },
  {
    question: `Does service filtering invade employee privacy?`,
    answer: (
      <Paragraph>
        Service filtering is designed to regulate access to certain services, not to monitor
        specific user activities. Businesses can create policies to manage service access without
        tracking individual behavior, preserving privacy while maintaining a secure, focused work
        environment.
      </Paragraph>
    ),
  },
  {
    question: `Can service filtering be customized for different roles or departments?`,
    answer: (
      <Paragraph>
        Yes, service filtering can be tailored to meet specific needs. Different teams or roles can
        have access to the services they need, while unnecessary services are restricted. This
        customization ensures each department operates efficiently without unrelated online
        distractions.
      </Paragraph>
    ),
  },
  {
    question: 'Is service filtering difficult to set up and manage?',
    answer: (
      <Paragraph>
        Modern service filtering solutions are built with ease of use in mind, featuring
        user-friendly interfaces and clear guidance. Setup and ongoing management require minimal
        technical knowledge, making it accessible to businesses without dedicated IT teams.
      </Paragraph>
    ),
  },
  {
    question: 'How is service filtering different from web filtering?',
    answer: (
      <Paragraph>
        While both provide control over internet use, service filtering specifically focuses on
        managing access to online applications and services, like video conferencing or file-sharing
        tools. Web filtering, by contrast, blocks or restricts access to certain websites or types
        of web content.
      </Paragraph>
    ),
  },
  {
    question: 'Can service filtering help with bandwidth management?',
    answer: (
      <Paragraph>
        Yes, service filtering can prioritize essential services over bandwidth-intensive,
        non-essential ones. By restricting access to high-bandwidth applications, businesses can
        ensure that network resources are reserved for critical tasks, improving overall network
        performance.
      </Paragraph>
    ),
  },
  {
    question: 'Can I try the service before purchasing a plan?',
    answer: (
      <Paragraph>
        Yes, {CONTROLDText} offers a 30-day risk-free trial for all organizations. Sign up with your
        business email and start testing the service—no credit card required.
      </Paragraph>
    ),
  },
  {
    question: 'Can I speak to someone for more details?',
    answer: (
      <Paragraph>
        Absolutely. You can <StyledLink to="/demo">book a demo</StyledLink> with our team at any
        time, and we&apos;d be happy to walk you through the features and answer any questions you
        have.
      </Paragraph>
    ),
  },
]
